import { render, staticRenderFns } from "./HistoryPesertaWidget.vue?vue&type=template&id=dfe7acca&scoped=true&"
import script from "./HistoryPesertaWidget.vue?vue&type=script&lang=ts&"
export * from "./HistoryPesertaWidget.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryPesertaWidget.vue?vue&type=style&index=0&id=dfe7acca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe7acca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable,VTab,VTabItem,VTabs,VTextField})
